import { useMemo } from 'react'
import type { Deal, DealStage } from '@/types'

/** Agrupa deals visíveis por etapa — uma passagem O(n) em vez de filter por coluna. */
export function useDealsByStage(visibleDeals: Deal[], stages: DealStage[]) {
  return useMemo(() => {
    const map = {} as Record<DealStage, Deal[]>
    for (const stage of stages) {
      map[stage] = []
    }
    for (const deal of visibleDeals) {
      const bucket = map[deal.etapa]
      if (bucket) bucket.push(deal)
    }
    return map
  }, [visibleDeals, stages])
}
